import CustomSweetAlert from 'components/Shared/CustomSweetAlert';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";

const StepSix = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({
        isConfirm: false
    });
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(prevState => ({
                ...prevState,
                isConfirm: storedData?.confirmedWorkTimeRegulations,
            }));
        }
    }, []);

    const validateForm = (formData) => {
        const { isConfirm } = formData;
        const errors = {
            isConfirm: isConfirm === false && 'A confirm is required',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitWorkingTimeRegulations?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                });
                if (response.status === 200) {
                    handleNext({ confirmedWorkTimeRegulations: formData });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const handleCheckIsConfirm = (e) => {
        setFormData({
            ...formData,
            isConfirm: !formData?.isConfirm
        })
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >6. Working Time Regulations</h2>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5><strong><u>RE: WORKING TIME REGULATIONS 1998</u></strong></h5></span>
                <span><h5>The above Regulations restrict the maximum hours which employees may work to a limit of an average of 48 hours per week including overtime, as measured over a 52-week period. The Regulations also permit employees to opt out of this limit if they wish to do so.</h5></span>
                <span><h5>FP McCann Ltd are inviting employees to give their written consent to override the restrictions imposed by the regulations. However, this does not commit the Company to provide work for 48 hours per week.</h5></span>
                <span><h5>Should you wish to waive your right to be limited to an average of 48 hours per week or less, and therefore wish to opt out of this provision of the Regulation, as you are entitled to, then you must sign the section detailed below and return the letter to me.</h5></span>
                <span><h5>The 48-hour limit will apply automatically if you do not sign the waiver of your rights beneath (subject to availability of work).</h5></span>
                <span><h5>Should you sign the waiver now, but subsequently wish to withdraw from it, you can do so by giving your manager 3 months notice in writing.</h5></span>
            </Col>

            <Col sm={12} md={12}>
                <Form.Group className='d-flex'>
                    <Form.Check.Label style={{ textAlign: 'left' }}>
                        <Form.Check.Input
                            type="checkbox"
                            checked={formData?.isConfirm === true}
                            onChange={handleCheckIsConfirm}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>I confirm that I wish to waive my right to be limited to working 48 hours per week or less under Article 5 of the Working Time Regulations 1998. I understand that should I wish to withdraw this waiver I must give 3 month's written notice to my manager.</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.isConfirm && <Form.Text className="text-danger d-flex"> <span className="star">*</span> {errors.isConfirm} </Form.Text>}
            </Col>

            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepSix;








